import { Component, inject } from '@angular/core';
import { ALL_LANGUAGES } from '../../../../../../common/utils/language.utils';
import { AppState, SetLanguageAction } from '../../../app.state';
import { select, Store } from '@ngxs/store';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { Language } from '../../../../../../common/dto/languages.dto';
import { RouteNavigationService } from '../../services/route-navigation.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-language-selector',
  imports: [
    MatMenuModule,
    MatButtonModule,
    FaIconComponent,
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent {
  private _store = inject(Store);
  private _routeNavigationService = inject(RouteNavigationService);

  protected appState = select(AppState.get);

  protected readonly ALL_LANGUAGES = ALL_LANGUAGES;

  public async onLanguageChangeAsync(language: Language) {
    if (language === this.appState().siteData?.language) {
      return;
    }

    await this._routeNavigationService.goToLanguageAsync(language);

    this._store.dispatch(new SetLanguageAction(language));
  }

  protected readonly faCaretDown = faCaretDown;
}
